import { Dialog, DialogContent } from "@mui/material";
import React from "react";
import ViewReverse from "./ViewReverse";
import { fontSizes } from "../constants/constants";
import Text from "./Text";
import Button from "./Button";
import { cn, getContentKeyAccToLang } from "../utils/utils";
import dynamicfunction from "../utils/dynamicfunction";
import { useSelector } from "react-redux";

const ConfirmModal = ({ open, onClose, title, description, onConfirm, loading, acceptText, cancelText, onPressNo, isCancel = true, isDisabled = false, isConfirmDisabled = false, isTop = false }) => {
  const { isArabic } = dynamicfunction();
  const fundsContent = useSelector((state) => state.content?.fundsContent);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(
      fundsContent?.web_funds_subscribe?.data?.attributes,
      key,
      isArabic
    );
  };

  return (
    <Dialog
      open={open}
      onClose={isCancel ? () => onClose?.(false) : null}
      fullWidth
      sx={{
        zIndex: isTop && 999999,
      }}
    >
      <DialogContent className="p-0 sm:min-w-96">
        <Text text={title} size={fontSizes.h20} className={"capitalize"} isCenter />

        <Text text={description} size={fontSizes.h14} className={"mt-4"} isTruncate={false} isCenter color="text-zinc-400" />
        <div className="h-6" />

        <ViewReverse
          className={"items-center justify-between rounded bg-white gap-4 mt-2"}
        >
          {
            isCancel &&
            <Button
              text={cancelText ?? getContentKey("cancel")}
              bgColor="bg-white"
              color={"text-dark-grey"}
              isDisabled={isDisabled}
              className={
                cn('text-center w-full px-0 border border-opacity-50', !isDisabled && 'border-dark-grey')
              }
              onClick={() => {
                onClose?.();
                onPressNo?.();
              }}
            />
          }
          <Button
            text={acceptText ?? getContentKey("confirm")}
            bgColor="bg-orange"
            className={"border border-orange w-full text-center max-w-70 px-4"}
            onClick={onConfirm}
            loading={loading}
            isDisabled={isConfirmDisabled}
          />
        </ViewReverse>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmModal;
